import { autoCapitalize } from '@/utils/autoCapitalize'
import { ProfessionalListAppointmentQueueData } from './ProfessionalListAppointmentQueueMapper.types'

class ProfessionalListAppointmentQueueMapper {
  toDomain(persistenceProfessionalData: ProfessionalListAppointmentQueueData) {
    return {
      id: persistenceProfessionalData?.id,
      name: autoCapitalize(
        persistenceProfessionalData?.nomeCompletoSemSaudacao,
      ),
      composedName: `${autoCapitalize(
        persistenceProfessionalData?.nomeCompletoSemSaudacao,
      )} - ${
        autoCapitalize(persistenceProfessionalData?.especialidade?.nome) ||
        persistenceProfessionalData?.tipoConselho
      } - ${autoCapitalize(persistenceProfessionalData?.clinica?.nome)}`,
    }
  }
}

export default new ProfessionalListAppointmentQueueMapper()
